export const hasMissingChatImageStorage = (message) => message?.image_storage_exists === false;

export const hasMissingChatFileStorage = (message) => message?.file_storage_exists === false;

export const resolveChatImageUnavailableText = (
  message,
  expiredText = '画像の保存期間は1週間です。',
) => (hasMissingChatImageStorage(message) ? '画像データが見つかりません。' : expiredText);

export const resolveChatFileUnavailableText = (
  message,
  expiredText = 'ファイルの保存期間は1週間です。',
) => (hasMissingChatFileStorage(message) ? 'ファイルデータが見つかりません。' : expiredText);
